import React, { createContext, useContext, useEffect, useState } from 'react';
import { apiRequest } from '../services/api';
import { applyTheme } from '../utils/applyTheme';

// Announcement bar, header and footer content from Admin → Customize.
// The last copy is kept in localStorage so repeat visits show the right header instantly,
// then it is refreshed from the server.
const SiteLayoutContext = createContext({ layout: null, loaded: false });

const CACHE_KEY = 'shabotique_layout_v1';

const readCache = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
};

export const SiteLayoutProvider = ({ children }) => {
  const [layout, setLayout] = useState(readCache);
  const [loaded, setLoaded] = useState(false);

  // Site-wide colours & fonts (cached copy first, so repeat visits don't flash the old colours)
  useEffect(() => {
    applyTheme(layout?.theme);
  }, [layout?.theme]);

  useEffect(() => {
    apiRequest('/content/layout')
      .then(data => {
        setLayout(data);
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        } catch {
          // storage full or blocked — the live copy is still used
        }
      })
      .catch(err => console.error('Could not load site layout', err))
      .finally(() => setLoaded(true));
  }, []);

  return (
    <SiteLayoutContext.Provider value={{ layout, loaded }}>
      {children}
    </SiteLayoutContext.Provider>
  );
};

export const useSiteLayout = () => useContext(SiteLayoutContext);
